import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";

interface ISettingsButtonProps {
    dataCyAttribute?: string;
    onClickOperation?: number;
    onClick?: (e: React.MouseEvent) => void;
    rightMargin?: number;
    alternativeIcon?: boolean;
    disabled?: boolean;
}
class SettingsButtonState {
}

class SettingsButton extends React.Component<ISettingsButtonProps, SettingsButtonState> {
    public render(): JSX.Element {
        var self = this;
        var marginStyle = null;

        if (this.props.rightMargin != null) {
            if (this.props.rightMargin >= 0) {
                marginStyle = {
                    marginRight: self.props.rightMargin
                };
            }
        }

        if (this.props.alternativeIcon === true) {
            return (
                <button data-cy={this.props.dataCyAttribute} className="button control alt-settings" disabled={this.props.disabled} style={marginStyle} onClick={this.handleClick.bind(this)}>
                    <span />
                </button>
            );
        }
        else {
            return (
                <button data-cy={this.props.dataCyAttribute} className="button control" disabled={this.props.disabled} style={marginStyle} onClick={this.handleClick.bind(this)}>
                    <i className="fi-widget" data-cy="fi-widget" />
                </button>
            );
        }
    }

    public handleClick(event: React.MouseEvent): void {
        event.stopPropagation();
        if (this.props.onClickOperation != null)
            LocalEvent.Dispatch(this.props.onClickOperation);
        if (this.props.onClick != null)
            this.props.onClick(event);
    }

    public componentWillUpdate(nextProps: ISettingsButtonProps): boolean {
        if (this.props.onClickOperation != null)
            return nextProps.onClickOperation !== this.props.onClickOperation;
    }
}

export { ISettingsButtonProps, SettingsButton, SettingsButtonState };
